import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LogData, MagicData } from 'src/app/shared/models/logdata';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  baseUrl: string = environment.cloudUrl;
  loginUrl: string = this.baseUrl + 'auth/catalogue/login';
  clearTime: any;
  magicurl:string=this.baseUrl + 'auth/magicLogin/catalogue/login';
  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private router: Router,
    public cookies: CookieService
  ) {}

  login(data: LogData): Observable<any> {
    const url = this.loginUrl;
    return this.http.post<LogData>(url, data).pipe(
      map((data) => {
        return data;
      }),
      catchError(this.handleError)
    );
  }
  handleError(error) {
    let errorMessage = '';
    if (
      error.error instanceof ErrorEvent ||
      error.status == 404 ||
      error.status == 401
    ) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = error.statusText;
    }
    return throwError(errorMessage);
  }

  logout() {
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'User Logout Successfully',
      life: 100000,
    });
    sessionStorage.clear();
    sessionStorage.clear();
    this.cookies.deleteAll();
    setTimeout(() => {
      this.routing();
    }, 500);
  }

  autoLogout(expiry: number) {
    this.clearTime = setTimeout(() => {
      this.logout();
    }, expiry);
  }
  routing() {
    if (this.clearTime) {
      clearTimeout(this.clearTime);
    }
    this.router.navigateByUrl('/login');
  }

  getData() {
    console.info('calling...');
    return this.http.get('assets/test.json');
    // .pipe(map(x => x));
  }
  magic_login(data: MagicData): Observable<any> {
    const url = this.magicurl;
    return this.http.post<MagicData>(url, data).pipe(
      map((data) => {
        return data;
      }),
      catchError(this.handleError)
    );
  }

  emailencrypt_token(data: any): Observable<any> {
    const url = this.magicurl;
    return this.http.post<any>(url, data).pipe(
      map((response) => response),
      catchError(this.handleError)
    );
  }
}
